module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper-md"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\n    Envie uma planilha (.xlsx, .xls ou .csv) para atualizar número, valores e status de vários lotes de um mesmo\n    leilão de uma só vez. A planilha deve ter uma linha de cabeçalho com as colunas:\n  ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\n    A GRV precisa já ter um lote cadastrado neste leilão — esta automação não cria lotes novos. Limite de 5MB e\n    2000 linhas por envio.\n  ")]), _vm._v(" "), (!_vm.leilao) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("ID do leilão")]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "max-width": "300px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.leilaoId),
      expression: "leilaoId"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "Ex: 123",
      "disabled": _vm.buscandoLeilao
    },
    domProps: {
      "value": (_vm.leilaoId)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.buscarLeilao.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.leilaoId = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "disabled": !_vm.leilaoId || _vm.buscandoLeilao
    },
    on: {
      "click": _vm.buscarLeilao
    }
  }, [(_vm.buscandoLeilao) ? _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }) : _c('i', {
    staticClass: "fa fa-search"
  })])])]), _vm._v(" "), (_vm.erroLeilao) ? _c('p', {
    staticClass: "text-danger m-t-xs"
  }, [_vm._v(_vm._s(_vm.erroLeilao))]) : _vm._e()]) : _c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v("\n    Leilão "), _c('strong', [_vm._v("#" + _vm._s(_vm.leilao.id))]), _vm._v(" — " + _vm._s(_vm.leilao.titulo) + "\n    "), (_vm.leilao.dataAbertura) ? _c('span', [_vm._v(" (" + _vm._s(_vm.formataData(_vm.leilao.dataAbertura)) + ")")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs btn-link",
    attrs: {
      "type": "button",
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.trocarLeilao
    }
  }, [_vm._v("\n      (trocar leilão)\n    ")])]), _vm._v(" "), (_vm.leilao) ? [(!_vm.arquivo) ? _c('div', {
    staticClass: "m-b"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.escolherArquivo
    }
  }, [_c('i', {
    staticClass: "fa fa-upload m-r-xs"
  }), _vm._v(" Selecionar planilha\n      ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "inputArquivo",
    attrs: {
      "type": "file",
      "accept": ".xlsx,.xls,.csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,text/csv"
    },
    on: {
      "change": _vm.onFileChange
    }
  })]) : _c('div', {
    staticClass: "m-b"
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-file-excel-o m-r-xs"
  }), _vm._v(" " + _vm._s(_vm.arquivo.name))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs btn-link",
    attrs: {
      "type": "button",
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.trocarArquivo
    }
  }, [_vm._v("\n        (trocar arquivo)\n      ")]), _vm._v(" "), (!_vm.resultado) ? _c('div', {
    staticClass: "m-t-sm"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.analisar
    }
  }, [_c('i', {
    staticClass: "fa fa-search m-r-xs"
  }), _vm._v(" Analisar planilha (pré-visualização)\n        ")])]) : _vm._e()])] : _vm._e(), _vm._v(" "), (_vm.resultado) ? _c('div', [_c('div', {
    staticClass: "alert",
    class: _vm.temResultadoAplicado ? 'alert-success' : 'alert-info'
  }, [_c('strong', [_vm._v(_vm._s(_vm.temResultadoAplicado ? 'Alterações aplicadas.' : 'Pré-visualização (nada foi gravado ainda).'))]), _vm._v(" "), _c('br'), _vm._v("\n      Total de linhas: " + _vm._s(_vm.resultado.totalLinhas) + " —\n      "), _c('span', {
    staticClass: "text-success"
  }, [_vm._v(_vm._s(_vm.resultado.totalAtualizadas) + " para atualizar")]), _vm._v(" —\n      "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.resultado.totalErros) + " com erro")])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive",
    staticStyle: {
      "max-height": "45vh",
      "overflow-y": "auto"
    }
  }, [_c('table', {
    staticClass: "table table-hover table-striped table-condensed b-t b-light"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.resultado.linhas), function(linha) {
    return _c('tr', {
      key: linha.linha
    }, [_c('td', [_vm._v(_vm._s(linha.linha))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(linha.numero))]), _vm._v(" "), _c('td', {
      class: _vm.corStatus(linha.status)
    }, [_c('i', {
      staticClass: "fa",
      class: _vm.iconeStatus(linha.status)
    }), _vm._v(" " + _vm._s(linha.status) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(linha.mensagem))])])
  }), 0)])]), _vm._v(" "), (_vm.temPreview) ? _c('div', {
    staticClass: "m-t"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": !_vm.podeConfirmar || _vm.loading
    },
    on: {
      "click": _vm.confirmar
    }
  }, [_c('i', {
    staticClass: "fa fa-check m-r-xs"
  }), _vm._v(" Confirmar e aplicar " + _vm._s(_vm.resultado.totalAtualizadas) + " alteração(ões)\n      ")]), _vm._v(" "), (!_vm.podeConfirmar) ? _c('span', {
    staticClass: "text-muted m-l-sm"
  }, [_vm._v("Nenhuma linha válida para aplicar.")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.temResultadoAplicado) ? _c('div', {
    staticClass: "m-t"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Fechar")])]) : _vm._e()]) : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-warning"
  }, [_c('strong', [_vm._v("Atenção:")]), _vm._v(" esta automação é específica para preparar lotes de leilão de\n    "), _c('strong', [_vm._v("veículos de roubo/furto")]), _vm._v(" — ela fixa o estado do veículo como \"Conservado\", a situação como\n    \"Recuperável\" e escreve \"VEÍCULO DE ROUBO E FURTO\" na observação/descrição do lote. Não use para outros tipos\n    de leilão.\n  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "text-muted"
  }, [_c('li', [_c('strong', [_vm._v("GRV")]), _vm._v(" — obrigatória, número da GRV")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("LOTE")]), _vm._v(" (ou \"Nº LOTE\") — número do lote")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Taxa de Arremate")]), _vm._v(", "), _c('strong', [_vm._v("Tabela Fipe")]), _vm._v(", "), _c('strong', [_vm._v("Avaliação")]), _vm._v(",\n      "), _c('strong', [_vm._v("Mínimo")]), _vm._v(", "), _c('strong', [_vm._v("Valor Inicial")]), _vm._v(" — valores em R$")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Placa")]), _vm._v(" — opcional")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Linha")]), _vm._v(" "), _c('th', [_vm._v("GRV")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Mensagem")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-510bdb62","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/automacoes/components/LotesLeilaoEmMassa.vue
// module id = 1856
// module chunks = 18